/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { FileObject } from 'object-types';
import { FileObjectItem } from 'items/file-object.item.factory';

export const FILE_OBJECT_COLLECTION_TOKEN = 'FileObjectCollection';

/**
 * @description FileObject Collection.
 * @author Rachit Aggarwal, alextsg
 */

export class FileObjectCollection extends Collection {
    public static ngDependencies = [FileObjectItem];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'fileobject',
            objectType: FileObject,
            permissionName: AviPermissionResource.PERMISSION_FILE_OBJECT,
            windowElement: 'lazy-load',
            searchFields: [
                'name',
                'type',
            ],
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getNgDependency(FileObjectItem);
    }
}

export type TFileObjectCollection = typeof FileObjectCollection;
